import { Record } from 'immutable';

import { DatablockListEntity } from '../components/datablock-list/datablock-list.entity';

export const DatablockSliceKey = 'main';

export interface IDatablockOriginalSliceState {
	loading: boolean;
	list: DatablockListEntity;
	includePublicProjects: boolean;
	isLoadingPersistence: boolean;
}

export const defaults: IDatablockOriginalSliceState = {
	loading: false,
	list: DatablockListEntity.build([]),
	includePublicProjects: false,
	isLoadingPersistence: false,
};
export class DatablockOriginalSliceState extends Record<IDatablockOriginalSliceState>(
	defaults
) {
	public static readonly key = DatablockSliceKey;

	public setLoading(isLoading: boolean): DatablockOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setDatablockList(
		datablockList: DatablockListEntity
	): DatablockOriginalSliceState {
		return this.set('list', datablockList);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): DatablockOriginalSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}

	public setLoadingPersistence(
		isLoading: boolean
	): DatablockOriginalSliceState {
		return this.set('isLoadingPersistence', isLoading);
	}
}
